import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const StarIcon = ({ title = 'Star', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 72 72" {...props}>
    {/* prettier-ignore */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.56 22.632l-19.33 2.81-.151.027c-1.529.336-2.108 2.263-.958 3.384L19.11 42.487l-3.302 19.254-.02.148c-.156 1.56 1.5 2.709 2.922 1.96L36 54.76l17.29 9.09.135.065c1.435.631 3.04-.588 2.768-2.173L52.89 42.487 66.88 28.853l.106-.111c1.039-1.17.375-3.07-1.215-3.3l-19.33-2.81-8.646-17.517c-.734-1.487-2.854-1.487-3.587 0L25.56 22.632z"
    />
  </CreateIconComponent>
);

export default StarIcon;
